import { useState, useCallback } from 'react';

/**
 * Hook local para manejar el estado de typing en el chat
 * Propósito: estado efímero ligado a UNA conversación específica
 * Controla si se muestra el típico "••• el asistente está escribiendo"
 */
export function useTypingIndicator() {
  const [isTyping, setIsTyping] = useState(false);

  const startTyping = useCallback(() => {
    setIsTyping(true);
  }, []);

  const stopTyping = useCallback(() => {
    setIsTyping(false);
  }, []);

  return {
    isTyping,
    startTyping,
    stopTyping,
  };
}
